export var google_unknown = "unknown_google_error";
export var facebook_unknown = "unknown_facebook_error";
export var unknown = "unknown_server_error";
export var login = "credentials_error";
export var user_exists = "user_already_exists";